import * as types from "./types";
import INITIAL_STATE from "./init";

// style guide: avoid destructuring state

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_DIVISION:
      return { ...state, ...action.payload };
    case types.SET_BENCHMARK_ACHIEVED:
      return {
        ...state,
        benchmark: { ...state.benchmark, achieved: action.payload },
      };
    default:
      return state;
  }
};
